module.exports = __webpack_public_path__ + "44ccc8da3f146ca2cdc6709733f5e7ff.svg";